import { render, staticRenderFns } from "./editdoc_payment_trans.vue?vue&type=template&id=425b0698&lang=true&"
import script from "./editdoc_payment_trans.vue?vue&type=script&lang=js&"
export * from "./editdoc_payment_trans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports